export const GLOBAL_INDUSTRY_CODES_RESET_STATE = 'GLOBAL_INDUSTRY_CODES_RESET_STATE';
export const GLOBAL_INDUSTRY_CODES_CURRENT_ITEM = 'GLOBAL_INDUSTRY_CODES_CURRENT_ITEM';

export const GLOBAL_INDUSTRY_CODES_REQUEST_LOADING = 'GLOBAL_INDUSTRY_CODES_REQUEST_LOADING';
export const GLOBAL_INDUSTRY_CODES_REQUEST_SUCCESS = 'GLOBAL_INDUSTRY_CODES_REQUEST_SUCCESS';
export const GLOBAL_INDUSTRY_CODES_REQUEST_FAILED = 'GLOBAL_INDUSTRY_CODES_REQUEST_FAILED';

export const GLOBAL_INDUSTRY_CODES_CURRENT_ACTION = 'GLOBAL_INDUSTRY_CODES_CURRENT_ACTION';
export const GLOBAL_INDUSTRY_CODES_RESET_ACTION = 'GLOBAL_INDUSTRY_CODES_RESET_ACTION';